import React, { memo, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';

interface Props {
	title: string;
	cardId: string;
	titleFont?: string;
	headerColor?: string;
}

const IntroAnimation: React.FC<Props> = ({ title, cardId, titleFont, headerColor }) => {
	const storageKey = `intro-played-${cardId}`;
	const [show, setShow] = useState(() => !sessionStorage.getItem(storageKey));

	useEffect(() => {
		if (!show) return;
		sessionStorage.setItem(storageKey, '1');
		const timer = setTimeout(() => setShow(false), 3000);
		return () => clearTimeout(timer);
	}, [show, storageKey]);

	const spring = useSpring({
		from: { opacity: 1, transform: 'scale(0.5)' },
		to: show
			? { opacity: 1, transform: 'scale(1)' }
			: { opacity: 0, transform: 'scale(1.1)' },
		config: { tension: 200, friction: 20 },
	});

	if (!show) return null;

	return (
		<animated.div
			style={{
				...spring,
				position: 'fixed',
				inset: 0,
				zIndex: 60,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: headerColor || '#4F46E5',
				pointerEvents: 'none',
			}}
		>
			<h1
				style={{
					fontFamily: titleFont || 'Inter',
					fontSize: 'clamp(2rem, 6vw, 5rem)',
					fontWeight: 700,
					color: '#FFFFFF',
					textAlign: 'center',
					padding: '0 2rem',
					textShadow: '0 2px 20px rgba(0,0,0,0.3)',
				}}
			>
				{title}
			</h1>
		</animated.div>
	);
};

export default memo(IntroAnimation);
